@use "sass:color";
@use "../../scss/util";

.groupme {
    background: util.$eRed;
    padding: 25px;

    &Wrap {
        max-width: 1200px;
        margin: 0 auto;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
    }
}

.gmPod {
    flex: 100%;
    text-align: center;

    @include util.mq(util.$md) { flex: 50%; }

    h2 {
        font-size: 2em;
        text-align: center;
        color: white;
        @include util.mq(util.$lg) { font-size: 2.5em; }
    }

    p {
        font-size: 1.3em;
        text-align: center;
        line-height: 1.5em;
        color: white;
        font-weight: 100;
        padding: 0 20px;
        @include util.mq(util.$lg) { font-size: 1.5em; }
    }
}

.gmLink {
    display: inline-block;
    padding: 12px 18px;
    background: util.$eBlue;
    color: white;
    text-decoration: none;
    border-radius: 12px;
    transition: .3s ease-in-out background;

    &:hover {
        background: color.scale(util.$eBlue, $lightness: -30%);
        transition: .3s ease-in-out background;
    }
}

.gmLogo {
    display: inline-block;
    width: 25px;
    height: auto;
    margin-right: 10px;
    vertical-align: middle;
}

.po {
    background-color: color.scale(util.$eBlueDark, $lightness: -30%);
    position: relative;
    padding: 50px 0 25px;

    &:before {
        content: "";
        display: block;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background: url("../../images/e-repeat.svg") repeat left top;
        background-size: 35px;
        opacity: .05;
        z-index: 0;
    }
}

.poHeaderBox {
    margin-bottom: 50px;

    @include util.mq(util.$lg) { margin-bottom: 100px }
    
    img {
        width: 100%;
        max-width: 900px;
        height: auto;
        display: block;
        margin: 0 auto;
    }
}

.poHeaderBox,
.fullPanel,
.resources { position: relative; z-index: 100 }

.fullPanel {
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
}

.panelContent,
.panelImage { 
    flex: 100%;
    display: flex;
    align-items: center;
}

.panelContent { @include util.mq(util.$md) { flex: 0 0 60% } }
.panelImage { @include util.mq(util.$md) { flex: 0 0 40% } }

.panelContent,
.panelImage {
    @include util.mq(util.$lg) { flex: 0 0 50% }
}

.swap {
    order: 100;
    @include util.mq(util.$md) { order: unset }
}

.panelContent {
    padding: 25px 50px;
    text-align: center;

    @include util.mq(util.$md) { padding: 0 50px;}
    @include util.mq(util.$xl) { padding: 25px 75px;}

    h2, p { color: white }
    
    h2 {
        color: white;
        font-size: 2.5em;
        line-height: 1.1em;

        @include util.mq(util.$md) {
            font-size: 1.8em;
            line-height: 1.5em;
        }

        @include util.mq(util.$xl) {
            font-size: 2.5em;
            line-height: 1.1em;
        }
    }

    p {
        font-size: 1.4em;
        line-height: 1.5em;
        font-weight: 200;

        @include util.mq(util.$md) {
            font-size: 1.2em;
            line-height: 1.6em;
        }

        @include util.mq(util.$xl) {
            font-size: 1.4em;
            line-height: 1.5em;
        }
    }
}

.panelImage img {
    width: 100%;
    height: auto;
    display: block;
}

.registerLink {
    display: block;
    background: util.$eGold;
    width: 250px;
    color: util.$eBlueDark;
    text-align: center;
    margin: 30px auto;
    text-decoration: none;
    padding: 18px 12px;
    border-radius: 6px;
    font-size: 1.2em;
    transition: .3s ease-in-out background;
    font-weight: 100;

    &:hover {
        transition: .3s ease-in-out background;
        background: util.$eBlue;
        color: white;
    }

    @include util.mq(util.$md) {
        width: 175px;
        padding: 12px 8px;
        font-size: 1.2em;
    }

    @include util.mq(util.$md) {
        width: 250px;
        margin: 30px auto;
        padding: 18px 12px;
        font-size: 1.2em;
    }
}

.resourceRegisterLink {
    display: inline-block;
    background: util.$eBlue;
    color: white;
    text-align: center;
    text-decoration: none;
    padding: 12px;
    border-radius: 6px;
    font-size: .9em;
    margin-top: 20px;
    transition: .3s ease-in-out background;

    &:hover {
        transition: .3s ease-in-out background;
        background: util.$eGold;
        color: util.$eBlueDark;
    }
}

.resources {
    $podBoxWidth: 1600px;
    $podBoxSideMarginTotal: 100px;
    $cardImgSquareWidth: 300px;
    
    max-width: $podBoxWidth;
    margin: 50px auto;

    .pods {
        display: flex;
        flex-wrap: wrap;

        .card {
            flex: 100%;

            display: flex;
            align-items: stretch;
            
            padding: calc($podBoxSideMarginTotal / 4);

            @include util.mq(util.$lg) { flex: 0 0 50% }

            .cardImg {
                content: "";
                display: none;
                height: 100%;
                min-height: $cardImgSquareWidth;
                flex-basis: $cardImgSquareWidth;
                border-top-left-radius: 25px;
                border-bottom-left-radius: 25px;

                @include util.mq(util.$md) { display: block }

                &.imgResource1,
                &.imgResource2 {
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: center;
                }

                &.imgResource1 { background-image: url("../../images/event-resources-1.jpg") }
                &.imgResource2 { background-image: url("../../images/event-resources-2.jpg") }
            }

            .cardInfo {
                background-color: white;
                flex-grow: 1;
                display: flex;
                border-top-right-radius: 25px;
                border-bottom-right-radius: 25px;
                padding: 30px;

                span {
                    display: block;
                }
            }
        }
    }
}

.resourceUl {
    li {
        margin-bottom: 10px;
        line-height: 1.2em;
        
        &.pdf { list-style-image: url("../../images/bullet-pdf.png");}
        &.document { list-style-image: url("../../images/bullet-document.png");}
        &.image { list-style-image: url("../../images/bullet-image.png");}

        a {
            color: util.$eBlueDark;
            &:hover { color: util.$eGreen }
            &:visited { color: util.$eRed }
        }
    }
}